import EzrVideo from "./EzrVideo";

export default EzrVideo;
